export default function WhyFastPassportCenterSection() {
  const bulletPoints = [
    "Real humans answer the phone during business hours",
    "Honest assessment — we'll tell you if your timeline is impossible",
    "Daily reserved agency submission slots — no public queue",
    "24 drop-off locations nationwide for same-day document submission",
    "20+ years of emergency passport experience",
    "A+ BBB accredited",
    "Registered State Dept. courier — on the official government list",
    "20–80% less expensive than FedEx or Staples passport counters",
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-red-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">Why It Matters</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Why Call <span className="text-red-600">Fast Passport Center First</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              In an emergency, <strong className="text-[#1A365D]">who you call matters.</strong> Fast Passport Center has been handling passport emergencies for over 20 years. We are a registered U.S. Department of State courier — not a call center, not a booking platform, not a referral service.
            </p>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              When you call <strong className="text-red-600">877-253-0084</strong>, a real passport specialist answers. We assess your situation in minutes and tell you honestly what's possible.
            </p>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              Our registered couriers have daily reserved submission slots at federal passport agencies — the same slots we use for every order, emergency or not. We don't have a separate "emergency line" at the agency. We have the same guaranteed daily access we've maintained for 20 years, which means your emergency application gets the same direct, reserved submission as every other order we handle.
            </p>
            <div className="mt-6">
              <a
                href="tel:8772530084"
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-sm px-7 py-3.5 rounded-md transition-all hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-phone-line"></i> Call 877-253-0084
              </a>
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-lg p-6 md:p-8">
            <ul className="space-y-4">
              {bulletPoints.map((point, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-700 text-sm">
                  <span className="text-red-600 mt-0.5 flex-shrink-0 font-bold">✓</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}